module.exports = __webpack_public_path__ + "static/pt-serif-v12-latin-italic-e080e39a107716904eaa71669f6894d9.woff";